import React from 'react';
import type { ProductsInsightsReport } from 'model/ProductsInsightsReport';
import NetSalesProductsBarChart from './charts/NetSalesProductsBarChart';

interface Props {
    loading: boolean;
    report: ProductsInsightsReport;
}

export const ProductsInsightsCharts: React.FC<Props> = ({ loading, report }) => {
    return (
        <NetSalesProductsBarChart
            loading={loading}
            report={report}
        />
    );
};

export default ProductsInsightsCharts;
